// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__uS6Wl","headerAndOrText":"styles_headerAndOrText__YrQI-","headerParantheses":"styles_headerParantheses__PHCB9"};